<template>
	<div v-if="accountPriceApply.platformType == 'weixin'" style="margin-top: 10px;">
		<a-form-item labelAlign="left" label="状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-radio-group  v-model="accountPriceApply.accountStatus">
				<a-radio disabled v-for="item in accountPriceStatusArr" :key="item.key" :value="item.key">{{item.value}}</a-radio>
			</a-radio-group>
		</a-form-item>

		<a-form-item required labelAlign="left" label="标签类型" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-input :disabled="!canEdit"  v-model="accountPriceApply.tagType"  placeholder="请输入标签类型" @blur="saveAccountPriceApplyField({tagType: accountPriceApply.tagType})"/>
		</a-form-item>

		<a-form-item required labelAlign="left" label="粉丝数" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-input-number :precision="1" :disabled="!canEdit"  v-model="accountPriceApply.fansNum"  placeholder="请输入粉丝数"  :min="0" :max="9999.9"  @blur="saveAccountPriceApplyField({fansNum: accountPriceApply.fansNum},'fansNum',accountPriceApply.fansNum)" />万
		</a-form-item>

		<a-form-item required labelAlign="left" label="简介" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-input :disabled="!canEdit"  type="textarea" v-model="accountPriceApply.intro"  placeholder="请输入简介" @blur="saveAccountPriceApplyField({intro: accountPriceApply.intro})"/>
		</a-form-item>

		<h4 style="text-align: center;">价格矩阵表({{accountPriceApply.accountPriceMonth}})</h4>
		<a-table :columns="columnsPrice" :dataSource="data" bordered size="middle" :pagination="false">
			<template v-for="item1 in columnsPrice[1].children[0].children" :slot="item1.dataIndex" slot-scope="text, record">
				<div style="background-color: beige">
					{{formatOriginal(record,item1.dataIndex)}}
				</div>
				<div :class="['editableFrame',formatStyle(record,item1.dataIndex)]">
					<div v-if="!canEdit">{{text}}</div>
					<div v-else>
						<editable-cell :text="text" @change="onCellChange(record,item1.dataIndex, $event)"/>
					</div>
				</div>
			</template>
			<template v-for="item2 in columnsPrice[1].children[1].children" :slot="item2.dataIndex" slot-scope="text, record">
				<div style="background-color: beige">
					{{formatOriginal(record,item2.dataIndex)}}
				</div>
				<div :class="['editableFrame',formatStyle(record,item2.dataIndex)]">
					<div v-if="!canEdit">{{text}}</div>
					<div v-else>
						<editable-cell :text="text" @change="onCellChange(record,item2.dataIndex, $event)"/>
					</div>
				</div>
			</template>
		</a-table>

		<a-form-item labelAlign="left" label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-top: 20px;">
			<a-input :disabled="!canEdit" type="textarea" v-model="accountPriceApply.remark"  placeholder="请输入备注" @blur="saveAccountPriceApplyField({remark: accountPriceApply.remark})"/>
		</a-form-item>
	</div>
</template>

<script>
import moment from 'moment';
import EditableCell from '@/components/editableCell/editableCell';

export default {
	components: { EditableCell },
	props: {
		accountPriceApply: {
			type: Object,
			default: null
		},
		canEdit: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		accountPriceApply: {
			immediate: true,
			handler(newVal, oldVal) {
				let accountId = newVal.accountId;
				let platformType = newVal.platformType;
				let accountPriceMonth = newVal.accountPriceMonth;
				if(platformType == 'weixin' && accountId && accountPriceMonth){
					this.getPriceDataList();
				}
			},
			deep: true
		},
	},
	data() {
		return {
			columnsPrice:[
				{
					title: '发布类型',
					dataIndex: 'releaseType',
					align:'center',
					width:'10%',
				},
				{
					title: '内容类型',
					width:'50%',
					children:[
						{
							title: '非原创',
							children: [],
							align: 'center'
						},
						{
							title: '原创',
							children: [],
							align: 'center'
						}
					]
				}
			],
			data: [],
			accountPriceStatusArr: [],
		};
	},
	mounted() {
		var that = this;
		//非原创
		that.$get('/weiboElement/list',{type:'non_original_weixin'}).then(res => {
			that.columnsPrice[1].children[0].children = [];
			for(var i of res.data.data){
				that.columnsPrice[1].children[0].children.push(
					{
						title: i.name,
						dataIndex: i.id,
						align:'center',
						scopedSlots: { customRender: i.id }
					}
				);
			}
		});
		//原创
		that.$get('/weiboElement/list',{type:'original_weixin'}).then(res => {
			that.columnsPrice[1].children[1].children=[];
			for(var i of res.data.data){
				that.columnsPrice[1].children[1].children.push(
					{
						title: i.name,
						dataIndex: i.id,
						align:'center',
						scopedSlots: { customRender: i.id }
					}
				);
			}
		});

		this.$get(`dictionary-detail/listByDictType/account_price_status`).then(res => {
			this.accountPriceStatusArr = res.data;
		});
	},
	methods: {
		formatStyle(record, index) {
			let status = record['status_' + index];
			if(status == 1){
				return 'add'
			}else if (status == 2){
				return 'delete';
			}else if (status == 3){
				return 'modify'
			}
			return '';
		},
		formatOriginal(record, index) {
			let status = record['status_' + index];
			if(status == 3){
				return record['originalPrice_' + index];
			}
			return '';
		},
		onCellChange(record, dataIndex, value, type) {
			var data = {
				accountPriceApplyId: this.accountPriceApply.id,
				releaseType: record.releaseKey,
				whetherMicrotask: record.whetherMicrotask=='1'?'1':'0',
				elementId: dataIndex,
			};
			if (value && parseFloat(value) >= 0) {
				data.price = parseFloat(value).toFixed(2);
				this.$post('/weiboPriceApply/save', data).then(res => {
					this.getPriceDataList();
				});
			} else {
				this.$delete('/weiboPriceApply/delete', data).then(res => {
					this.getPriceDataList();
				});
			}
		},
		getPriceDataList() {
			this.data = [];
			this.$get('/weiboPriceApply/listPrice/weixin_release_type', { accountPriceApplyId: this.accountPriceApply.id}).then(res => {
				this.data = res.data;
			});
		},
		saveAccountPriceApplyField(data,type,value){
			if (type == 'fansNum' && value == null) {
				this.$message.warning("粉丝数不能为空");
				this.accountPriceApply.fansNum = 0;
				data = {fansNum: 0};
			}
			var param = {
				...data,
				id: this.accountPriceApply.id
			};
			this.$post('/accountPriceApply/saveAccountPriceApplyField', param);
		}
	},
};
</script>

<style lang="less" scoped>
	.add{
		background-color: palegreen;
	}
	.delete{
		background-color: orangered;
	}
	.modify{
		background-color: yellow;
	}
/deep/.editableFrame {
	.editable-cell {
		position: relative;
	}

	.editable-cell-input-wrapper,
	.editable-cell-text-wrapper {
		padding-right: 24px;
	}

	.editable-cell-text-wrapper {
		padding: 5px 24px 5px 5px;
	}

	.editable-cell-icon,
	.editable-cell-icon-check {
		position: absolute;
		right: 0;
		width: 20px;
		cursor: pointer;
	}

	.editable-cell-icon {
		line-height: 18px;
		display: none;
	}

	.editable-cell-icon-check {
		line-height: 28px;
	}

	.editable-cell:hover .editable-cell-icon {
		display: inline-block;
	}

	.editable-cell-icon:hover,
	.editable-cell-icon-check:hover {
		color: #108ee9;
	}

	.editable-add-btn {
		margin-bottom: 8px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/weixinPrice.vue